import { render, staticRenderFns } from "./Permiso.vue?vue&type=template&id=3fae5202&"
import script from "./Permiso.vue?vue&type=script&lang=js&"
export * from "./Permiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports